<script>
import Banner from '../components/banner.vue';
import Logos from '../components/logos.vue';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { mapState } from 'vuex';
import ImagesSwiper from '../components/imagesSwiper.vue';

export default {
    name: "facility",
    data() {
        return {
            swiperOptions: {
                simulateTouch: false,
                spaceBetween: '1.67%',
                navigation: {
                    nextEl: '.list .swiper-button-next',
                    prevEl: '.list .swiper-button-prev',
                },
            },
        };
    },
    computed: {
        ...mapState(['facilityData']),
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    directives: {
        swiper: directive
    },
    components: {
        Banner,
        Logos,
        Swiper,
        SwiperSlide,
        ImagesSwiper
        
    },
    mounted() {
        this.$store.dispatch('getFacilityData');
    },
    destroyed() {},
    watch: {},
    methods: {
        toLink(link) {
            if (link) { 
                window.open(link);
            }
        }
    },
};
</script>

<template>
    <div class="facility">
        <Banner :banner="facilityData.info.image" :title="facilityData.info.name" :desc="facilityData.info.desc"/>
        <div class="layout_main">
            <div class="layout_swiper list">
                <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide v-for="(item, index) in facilityData.list" :key="index" :class="`type${item.type}`">
                        <template v-for="(item, index) in item.list">
                            <div class="item" :class="{is_link: item.link}" v-if="item.image" @click="toLink(item.link)">
                                <div class="zheng" :style="`background-image: url(${item.image});`"></div>
                                <div class="fan" :style="`background-image: url(${item.image});`">
                                    <div class="text">
                                        <div class="name">{{ item.name }}</div>
                                        <div class="desc">{{ item.desc }}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </swiper-slide>
                    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
        <div class="layout_main swiper_mobile">
            <ImagesSwiper :data="facilityData.list_mobile"/>
        </div>
        <Logos v-if="facilityData.website.length > 0" :data="facilityData.website"/>
    </div>
</template>

<style scoped lang="scss">
.facility{
    .swiper_mobile{
        display: none;
        @media only screen and (max-width: 750px) {
            display: block;
            padding-top: .6rem;
        }
    }
    .list{
        margin-top: .8rem;
        @media only screen and (max-width: 750px) {
            display: none;
        }
        .swiper-slide{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            &.type1{
                .item{
                    &:nth-of-type(1){
                        width: 4.56rem;
                    }
                    &:nth-of-type(2),
                    &:nth-of-type(3){
                        width: 3.51rem;
                    }
                    &:nth-of-type(4),
                    &:nth-of-type(5){
                        width: 5.89rem;
                        margin-top: .2rem;
                    }
                }
            }
            &.type2{
                .item{
                    &:nth-of-type(3){
                        width: 4.56rem;
                    }
                    &:nth-of-type(4),
                    &:nth-of-type(5){
                        width: 3.51rem;
                    }
                    &:nth-of-type(1),
                    &:nth-of-type(2){
                        width: 5.89rem;
                        margin-bottom: .2rem;
                    }
                }
            }
            .item{
                position: relative;
                height: 2.7rem;
                perspective: 3000px;
                &.is_link{
                    cursor: pointer;
                }
                &:hover{
                    .zheng{
                        transform: rotateX(-180deg);
                    }
                    .fan{
                        transform: rotateX(0deg);
                        .text{
                            transform: translate(0, 0);
                        }
                    }
                }
                .zheng,
                .fan{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                    &,
                    .text{
                        transition: transform .8s;
                    }
                }
                .zheng{
                    z-index: 1;
                    backface-visibility: hidden;
                }
                .fan{
                    transform: rotateX(180deg);
                    overflow: hidden;
                    &::before,
                    .text{
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                    &::before{
                        content: "";
                        background: rgba($color: #000000, $alpha: .25);
                    }
                    .text{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        padding: 0 .3rem;
                        text-align: center;
                        transform: translate(0, -50%);
                        .name{
                            font-size: .36rem;
                            margin-bottom: .2rem;
                        }
                        .desc{
                            font-size: .18rem;
                        }
                    }
                }
            }
        }
    }
}
</style>